import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const ROUTE_TITLE = {
  "/": "title.home",
  "/test/knowledge": "title.knowledge",
  "/checklist/fake-nlp": "title.checklist",
  "/leaderboards": "title.leaderboards",
  "/blog": "title.blog",
  "/wiki": "title.wiki",
  "/login": "title.login",
  "/admin": "title.admin",
};

export default function TitleManager() {
  const { pathname } = useLocation();
  const { t, lang } = useLanguage();

  useEffect(() => {
    // Blog & Wiki article pages set their own title once content loads.
    if (pathname.startsWith("/blog/") || pathname.startsWith("/wiki/")) return;
    const key = ROUTE_TITLE[pathname] || "title.home";
    document.title = t(key);
  }, [pathname, lang, t]);

  return null;
}
